import React from 'react';
import IconWrapper from '../IconWrapper';
const PauseVideoIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props),
    React.createElement("rect", { width: "1", height: "15", x: ".5", y: ".5", rx: ".5" }),
    React.createElement("rect", { width: "1", height: "15", x: "9", y: ".5", rx: ".5" })));
export default PauseVideoIcon;
//# sourceMappingURL=PauseVideoIcon.js.map